import { forwardRef, type Ref, type SVGProps } from "react";
const IconCoolingOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M28.474 17.71a1 1 0 0 0-1.23-.71l-5.06 1.34-4.2-2.34 4.2-2.34 5.06 1.34h.26a1 1 0 0 0 1-.71 1 1 0 0 0-.71-1.18l-3.13-.81 3.1-1.73a.94.94 0 0 0 .37-1.31 1 1 0 0 0-1.37-.35l-3.1 1.72.84-3a1 1 0 0 0-.71-1.18 1 1 0 0 0-1.22.68L21.184 12l-4.2 2.33V9.66l3.7-3.57a.94.94 0 0 0 0-1.36 1 1 0 0 0-1.41 0l-2.29 2.2V3a1 1 0 1 0-2 0v4l-2.29-2.2a1 1 0 0 0-1.41 0 .94.94 0 0 0 0 1.36l3.7 3.5v4.67l-4.2-2.33-1.36-4.88a1 1 0 0 0-1.22-.68 1 1 0 0 0-.71 1.18l.84 3-3.1-1.71a1 1 0 0 0-1.37.35.94.94 0 0 0 .37 1.31l3.1 1.73-3.13.81a1 1 0 0 0-.71 1.18 1 1 0 0 0 1 .71h.26l5.03-1.34 4.2 2.34-4.2 2.34L4.724 17a1 1 0 0 0-1.23.68 1 1 0 0 0 .71 1.18l3.13.81-3.1 1.73a.94.94 0 0 0-.37 1.31 1 1 0 0 0 1.37.35l3.1-1.72-.84 3a1 1 0 0 0 .71 1.18.8.8 0 0 0 .26 0 1 1 0 0 0 1-.72l1.32-4.8 4.2-2.33v4.67l-3.7 3.57a.94.94 0 0 0 0 1.36 1 1 0 0 0 1.41 0l2.29-2.2v4a1 1 0 1 0 2 0v-4l2.29 2.2a1 1 0 0 0 1.41 0 .94.94 0 0 0 0-1.36l-3.7-3.57v-4.67l4.2 2.33 1.36 4.87a1 1 0 0 0 1 .72.8.8 0 0 0 .26 0 1 1 0 0 0 .71-1.18l-.84-3 3.1 1.72a1 1 0 0 0 1.37-.35.94.94 0 0 0-.37-1.31l-3.1-1.73 3.13-.81a1 1 0 0 0 .67-1.22"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCoolingOutlineSVG);
ForwardRef.displayName = "IconCoolingOutline";
export { ForwardRef as IconCoolingOutline };
